import React from "react";
import styles from "../messenger.module.css";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { AiOutlineUser } from "react-icons/ai";

const ClientMessenger = ({}) => {
  const history = useHistory();
  const [user, setUser] = useState([]);
  const [admissionar , setAdmissionar] = useState([])


  useEffect(()=>{
    getUser()
  } , []);


  const getUser = () => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-user/${"9cGAXGCLvpkyioQxiqgaKhTiJFz2qMYeX623uuQBlj6BRFg2KyNgrUki3VA3xryqfkD23m2zCmOxQ4AD"}`)
      .then((response) => {
        console.log("user", response.data);
        setUser(response.data);
        axios.get(`https://arianaapp.arianaapply.com/api/V1/show-client-admissioner/${response.data._id}`)
        .then(res=>{
          console.log('admision' , res);
          setAdmissionar(res.data[0].user);
        }).catch(err=>{
          console.log(err.response)
        })
      });
  }

  const getConverstion = () => {
    axios.post(
      `https://arianaapp.arianaapply.com/api/V1/chat/get-messages`,
      {
        admissioner_id: admissionar._id,
        client_id: user._id,
      },
    ).then(res=>{
        console.log(res);
        history
        .push({
          pathname: `/messenger/chat/${res.data[0].conversation_id}`,
          state: {
            receiver: admissionar,
            conversation_id: res.data[0].conversation_id,
            myUser: user,
            members: res.data[1].members,
          },
        })
    }).catch(err=>{
        console.log(err.response);
    })
  };


  return (
    <div className={styles.messenger}>
      <div
      className={styles.senderMessage}
      onClick={() => getConverstion()}
    >
      <div className={styles.senderImage}>
        <AiOutlineUser size={32} color="#059669" />
      </div>
      <div className={styles.senderDetails}>
        <h3>{admissionar.name}</h3>
        <p>
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده
          از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و
          سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای
          متنوع با هدف بهبود ابزارهای کاربردی می
        </p>
      </div>
      <div className={styles.sendingTime}>
        <span>14:30</span>
      </div>
    </div>
    </div>
  );
};

export default ClientMessenger;
